import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    baseURL: '/api', 
    timeout: 10000, // 增加超时时间到10秒
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    }
    
    const currentLang = localStorage.getItem("lang") || 'en';
    const token = localStorage.getItem('token');
    
    config.headers['lang'] = currentLang.toLowerCase();
    if(token){
        config.headers['token'] = Base64.encode(token);
    }
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    return res 
},err=>{
    return Promise.reject(err);
})

/**
 * 安全解析后端返回的 Base64 数据
 */
function safeParseData(data) {
    if (!data) return data;
    // 如果已经是对象或数组，直接返回
    if (typeof data === 'object') return data;
    
    try {
        // 尝试 Base64 解码并 JSON 解析
        return JSON.parse(Base64.decode(data));
    } catch (e) {
        // 如果解析失败，说明可能不是加密字符串，直接返回原数据
        console.warn("Data parse warning: data is not a base64 string", e);
        return data;
    }
}

//封装axios请求方法
async function http(option = {}) {
    let result = null
    try {
        if(option.method === 'get' || option.method === 'delete'){
            const res = await instance[option.method](api[option.url], {params: option.data});
            result = res.data;
            if (result && result.data) {
                result.data = safeParseData(result.data);
            }
        } else if(option.method === 'post' || option.method === 'put'){
            const res = await instance[option.method](api[option.url], qs.stringify(option.data));
            result = res.data;
            if (result && result.data) {
                result.data = safeParseData(result.data);
            }
        }
    } catch (err) {
        console.error("HTTP Request Error:", err);
        result = { code: 500, msg: "Network Error", data: null };
    }
    return result
}

export default http